import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5ytgyrzl: FaireBrandEntity = {
  token: "b_5ytgyrzl",
  type: "brand",
  name: "BirdRock Baby",
  avatarUrl:
    "https://cdn.faire.com/fastly/121ecabb53c355c3f3b1851dec38f93c33bef2d152268985dee5de0a6756f81b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7b1a51643ffaafcc8742b54304270d8655e019b053c23869ee9869287b064a78.png",
  logoUrl:
    "https://cdn.faire.com/fastly/121ecabb53c355c3f3b1851dec38f93c33bef2d152268985dee5de0a6756f81b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7b1a51643ffaafcc8742b54304270d8655e019b053c23869ee9869287b064a78.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 67,
  isInsider: true,
  description:
    "Envisioned by two working families in San Diego, we created BirdRock Baby as an opportunity to fulfill our dream of owning a small business. We offer products we are proud of, at prices real families can afford! Our flagship products are our genuine leather baby moccasins, and our organic cotton baby booties, both of which have received hundreds of 5 star reviews from parents around the world. Giving back is a core principle of BirdRock Baby. Every BirdRock Baby product (including wholesale sales!) feeds a child in need for an entire day through our partner charity, Feed My Starving Children. \n\nWe are excited to partner with brick and mortar shops like you! We are committed to the success of our wholesale partners, and we promise to treat you like family. Please note that our wholesale terms allow for sales on your branded website but do not include online marketplace sales. \n\n*New!* We are happy to announce our core colors collection and are also proud to carry a phenomenal family backpack in 3 shades. If you would like to make a custom order, please reach out and note that each case contains 32 units of that SKU. \n\nAs always, please free to message us if you have any questions, thank you. :) ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:36.030Z",
    importedBy: "entity-db-cli",
  },
};
